import { keys } from "../../../../../constants/keys";

export default function useGetRiskKey(riskLevel: number | undefined) {
  if (!riskLevel) return null;
  return keys.filter((key) => riskLevel === key.level);
}
